import { Component, OnInit } from '@angular/core';
import { Autista } from 'src/app/def/structures';
import { BatchOperation } from 'src/app/def/types';
import { DBFirestoreService } from 'src/app/dbfirestore.service';

@Component({
    selector: 'odl-admin-autisti',
    templateUrl: './autisti.component.html',
    styleUrls: ['./autisti.component.scss']
})
export class OdlAdminAutistiComponent implements OnInit {

    autisti: Autista[] = [];
    newautisti: Partial<Autista>[] = [];
    newrow: Partial<Autista> = {
        nome: '',
        cognome: '',
        disabled: false,
    }

    batchops: BatchOperation[] = [];
    toDelete: string[] = [];

    rawinput: string;

    constructor(
        private db: DBFirestoreService
    ) { }

    ngOnInit() {
        this.db.collectionAutisti(true).subscribe( autisti => this.autisti = autisti );
    }

    addNew() {
        if ( !this.newrow.nome || !this.newrow.cognome) {
            return;
        }
        this.newautisti.push({
            nome: this.newrow.nome,
            cognome: this.newrow.cognome,
            disabled: this.newrow.disabled,
        })
        this.newrow.nome = '';
        this.newrow.cognome = '';
        this.newrow.disabled = false;

        this.commit();
    }

    /*
    delete(autista) {
        this.db.deleteAutista(autista).then( () => {
            console.log('deleted');
        }).catch( error => {
            this.onError('errore cancellazione autista', error)
        });
    }
    */

    delete(autista) {
        if ( !confirm('Questa operazione eliminerà in modo permanente l\'autista. Piuttosto che cancellarlo, è consigliabile disattivarlo per non perdere l\'associazione con gli ordini inseriti.'+"\n\n"+' Sei sicuro di voler procedere?') ) {
            return;
        }
        this.db.deleteAutista(autista).then( () => {
            console.log('deleted');

        }).catch( error => {
            this.onError('errore cancellazione autista', error)
        });
    }

    disable(autista) {
        autista.disabled= true;
        this.db.updateAutista(autista).catch( error => {
            alert('Operazione non riuscita');
            console.log(error);
        })
    }

    enable(autista) {
        autista.disabled= false;
        this.db.updateAutista(autista).catch( error => {
            alert('Operazione non riuscita');
            console.log(error);
        })
    }


    
    commit() {
        this.addNew();
        this.batchops = [];
        this.batchops = this.newautisti.map( autista => {
            return this.db.batchAddAutista({
                id: null,
                nome: autista.nome,
                cognome: autista.cognome,
                disabled: autista.disabled,
            });
        });
        
        this.db.batch(this.batchops).then( result => {
            this.batchops = [];
            this.newautisti = [];
        }).catch( error => {
            this.onError('Errore procedura di aggiornamento', error)
        });
    }


    importCopyPaste() {
        const rows = this.rawinput.split(/\n/);
        rows.forEach( row => {
            if (!row) return;
            const cols = row.trim().split(/\t/);
            if ( !cols || (cols.length != 3)) {
                return;
            }
            this.newautisti.push({
                nome: cols[1],
                cognome: cols[2],
                disabled: false,
            })
        })
    }

    onError(title: string, extra: any) {
        alert(title);
        console.log(extra);
    }

    toggleNewDisabled(event) {
        console.log(event.target.checked);
        this.newrow.disabled = !event.target.checked;
    }
}
